import { DISCIPLINE, PAGINEDETAIL } from 'utils/endpoint'

import Breadcrumbs from 'components/atomic/Breadcrumbs'
import DisciplinaCard from 'components/card/DisciplinaCard'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import Head from 'next/head'

const DisciplineAll = ({ discipline = [], page }) => {
  const list = discipline.map(disciplina => (
    <div className="col col-sm-6 col-md-4 col-lg-3" key={disciplina.id}>
      <DisciplinaCard disciplina={disciplina} />
    </div>
  ))

  return (
    <>
      <MetaSeo seo={page.seo} />
      <main className="discipline-page">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />

          <section className="discipline-page__header">
            {page.main_image ? (
              <>
                <Head>
                  <link rel="preload" href={page.main_image} as="image" />
                </Head>
                <img
                  src={page.main_image}
                  alt={page.titolo?.toAltTitle()}
                  title={page.titolo?.toAltTitle()}
                  className="discipline-page__image"
                />
              </>
            ) : null}

            <h1 className="discipline-page__header__title heading1">{page.titolo}</h1>

            <p className="discipline-page__header__abstract abstract-medium">{page.descrizione}</p>
          </section>

          <section className="discipline-page__list row">{list}</section>
        </div>
      </main>
    </>
  )
}

export const getStaticProps = async () => {
  const response = await api.get(DISCIPLINE)
  const discipline = response.data

  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'discipline-all',
    },
  })
  const page = await pageResponse.data

  const toolbarProps = { toolbarPage: page }

  return { props: { discipline, page, ...toolbarProps }, revalidate: 60 * 2 }
}

export default DisciplineAll
